import { apiClient } from "@/api/client";
import { endpoints } from "@/api/endpoints";
import type { ApiResponse } from "@/api/types";
import type { JobHealthDto } from "./jobHealth.types";

export const jobHealthService = {
  async list(): Promise<JobHealthDto[]> {
    const { data } = await apiClient.get<ApiResponse<JobHealthDto[]>>(endpoints.auditLog.jobHealth);
    return data.data;
  },
};
